import exifr from 'exifr'

const getAddressFromCoordinates = async (lat, lng) => {
  const url = `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`

  try {
    const res = await fetch(url, {
      headers: {
        'User-Agent': 'YourAppName/1.0 (your.email@example.com)', // bắt buộc với Nominatim
      },
    })
    const data = await res.json();
    return data ? {
      addressDescription: data.display_name,
      addressCity: data.address?.city || data.address?.town || data.address?.village || '',
      addressPostalCode: data.address.postcode,
      addressCountry: data.address?.country_code,
    }: null
  } catch (err) {
    return null
  }
}

export const extractExifAndAddress = async (file) => {
  // const address = await getAddressFromCoordinates(20.995, 105.776);
  // return address
  try {
    const exif = await exifr.gps(file);
    if (exif?.latitude && exif?.longitude) {
      const address = await getAddressFromCoordinates(exif.latitude, exif.longitude)
      return address
    }
    return null;
  } catch (err) {
    console.log('EXIF error:', err)
    return null
  }
}